import { render, staticRenderFns } from "./ScannedSkus.vue?vue&type=template&id=06c9a09c&"
import script from "./ScannedSkus.vue?vue&type=script&lang=js&"
export * from "./ScannedSkus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports